export const CAMPAIGN_TYPE_LABELS: Record<string, string> = {
  triggered_broadcast: 'API-Triggered Broadcast',
  behavioral: 'Event Triggered',
  seg_attr: 'Segment Triggered',
  date: 'Date Triggered',
  form: 'Form Submitted',
  webhook: 'Webhook',
  transactional: 'Transactional',
  relationship: 'Relationship',
  object: 'Object',
  none: 'Campaign',
};

export const SEGMENT_TYPE_LABELS: Record<string, string> = {
  static: 'Manual',
  dynamic: 'Data-Driven',
  temporary: 'Temporary',
  hidden: 'Hidden',
};
